<template>

  <div>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">{{$t('pages.adminpanel.users.listOfUsers')}}</h3>

        <div class="box-tools">
          <div class="input-group input-group-sm" style="width: 150px;">
            <input type="search" name="table_search" class="form-control pull-right" :placeholder="$t('pages.adminpanel.users.search')" v-model="searchUsers">

            <div class="input-group-btn">
              <button type="submit" @click.prevent="getUsers(searchUsers)" class="btn btn-default">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body table-responsive no-padding">
        <table class="table table-hover">
          <tbody>
            <tr>
              <th>{{$t('pages.adminpanel.users.tableId')}}</th>
              <th>{{$t('pages.adminpanel.users.tableUser')}}</th>
              <!-- <th>{{$t('pages.adminpanel.users.tableDate')}}</th> -->
              <th>{{$t('pages.adminpanel.users.tableRole')}}</th>
              <th></th>
            </tr>
            <tr v-for="usr in users" :key="usr.id">
              <td>{{usr.id}}</td>
              <td>
                <a class="hoverRole" @click.prevent="showUserData(usr)">{{usr.firstName}} {{usr.lastName}}</a>
              </td>
              <!-- <td>{{usr.createdAt.substring(0,4)}}</td> -->
              <td>
                <span v-for="role in usr.implicitRoles">
                  <div v-if="role.name == 'admin.user'" class="badge bg-red">{{role.displayName}}</div>
                  <div v-else-if="role.name == 'admin.group'" class="badge bg-green">{{role.displayName}}</div>
                  <div v-else-if="role.name == 'admin.device'" class="badge bg-blue">{{role.displayName}}</div>
                  <div v-else-if="role.name == 'admin'" class="badge">{{role.displayName}}</div>
                </span>
                <a id="addRole" @click.prevent="addNewRole(usr.id)">
                  <div class="" v-if="usr.implicitRoles.length == 0">
                  </div>
                </a>
              </td>
              <td>
                <!-- TODO: translate -->
                <a data-toggle="tooltip" title="Resend invitation" v-if="!usr.hasPassword" @click.prevent="resendInvite(usr.id)" class="btn btn">
                  <i class="fa fa-mail-forward"></i>
                </a>
                <a v-else-if="false" @click.prevent="" class="btn btn">
                  <i class="fa  fa-eye  "></i>
                </a>
                <a v-if="usr.id != me.id" @click.prevent="deleteUser(usr.id)" class="btn btn-danger">
                  <i class="fa fa-trash"></i> 
                </a>
              </td>
            </tr>
          </tbody>
        </table>
       <nav aria-label="Page navigation example">
        <ul class="pagination pull-right" style="margin-right: 10px">
          <li class="page-item" :class="[pagination.page === 1 ? 'disabled' : '']"><a class="page-link" href="#" @click.prevent="getUsers('', pagination.page - 1)">Previous</a></li>
          <li class="page-item" :class="[pagination.page === result+1 ? 'active' : '']" v-for="(result, index) in getDisplayedPages(pagination.page)"><a @click.prevent="getUsers('', result + 1)" class="page-link" href="#">{{result+1}}</a></li>
          <li class="page-item" :class="[pagination.page === pagination.totalPageCount ? 'disabled' : '']"><a class="page-link" href="#" @click.prevent="getUsers('', pagination.page + 1)">Next</a></li>
        </ul>
      </nav>
      </div>
      <!-- /.box-body -->
    </div>
  </div>

</template>

<script>
  // import router from './../../router/router'
  import Rest from './../../services/rest'
  import createuser from './../admin/CreateUser'
  import { mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    data () {
      return {
        users: [],
        searchUsers: '',
        pagination: [],
        fields: [ 'id' ]
      }
    },
    computed: {
      ...mapState({
        me: state => state.userData
      })
    },
    methods: {
      getDisplayedPages (selectedPage) {
        let numbers = []
        if (this.pagination.totalPageCount > 10) {
          if (selectedPage < 5) {
            for (let i = 0; i < 10; i++) {
              numbers.push(i)
            }
          } else if (selectedPage > this.pagination.totalPageCount - 5) {
            for (let i = this.pagination.totalPageCount - 10; i < this.pagination.totalPageCount; i++) {
              numbers.push(i)
            }
          } else {
            for (let i = selectedPage - 5; i < selectedPage + 5; i++) {
              numbers.push(i)
            }
          }
        } else {
          for (let i = 0; i < this.pagination.totalPageCount; i++) {
            numbers.push(i)
          }
        }
        return numbers
      },
      showUserData (usr) {
        this.$router.push({ name: 'profileOfAdmin', params: { uid: usr.id.toString() } })
      },
      getUsers (searchQuery, pageNumber) {
        if (pageNumber < 1 || pageNumber > this.pagination.totalPageCount) {
          return
        }
        if (searchQuery === '') searchQuery = undefined
        let postdata = {
          query: searchQuery,
          page: pageNumber
        }
        return Rest.request('POST', '/users/searchPaginated', postdata).then((data) => {
          this.users = data.results
          this.pagination = _.omit(data, 'results')
        }).catch(function (err) {
          console.log(err)
        })
      },
      deleteUser (uId) {
        var answer = confirm('Are you sure?')
        if (answer) {
          let tren = this
          return Rest.request('DELETE', '/users/' + uId).then(function (data) {
            tren.getUsers()
          }).catch(function (err) {
            console.log(err)
          })
        }
      },
      resendInvite (uId) {
        return Rest.request('GET', '/users/' + uId + '/resendInvitation').then(function (data) {
        }).catch(function (err) {
          console.log(err.responseJSON['message'])
        })
      }
    },
    subscriptions () {
      return {
        userSearch: this.$watchAsObservable('searchUsers').map((val) => val.newValue)
        .debounceTime(500)
        .distinctUntilChanged()
        .do({
          next: (searchQ) => {
            this.getUsers(searchQ)
          }
        })
      }
    },
    created () {
    },
    mounted () {
      this.getUsers()
    },
    components: {
      createuser: createuser
    }
  }
</script>

<style>
#addRole:hover {
  cursor: pointer;
}
.hoverRole {
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// Users.vue?01109f2e